import { baseUrl, environment } from "../environment";
import {
  AttandanceDetailPayload,
  AttendanceApprovalDetailsPayload,
  AttendanceApprovalPayload,
  AttendanceDashboardPayload,
  AttendanceTimeSheetCalculationPayload,
  DaywiseAttendancePayload,
  DaywiseAttendanceReportPayload,
  DeleteEmployeeAttendanceBatchPayload,
  EditAttendancePayload,
  GetAllEmpAttendenceMonthlyPayload,
  GetEmpAttendanceYrlySummaryPayload,
  MonthwiseEmpAttendenceDetailsPayload,
  MyAttendancePayload,
  PendingApprovalListPayload,
  PendingAttendancePayload,
  SendForApprovalPayload,
  SubmitTodaysTimesheetPayload,
  UpdateAttendaceStatusPayload,
  UpdateAttendancePayload,
  UploadAttendanceTimeSheetPayload,
  uploadAttendanceViewForVariable,
  ViewTeamAttendancePayload,
  GenerateMonthlyReportPayload,
  FutureAttendanceApprovalListPayload,
  FutureAttendanceApprovalUpdateStatusPayload,
  OrganizationReportDataPayload,
} from "../models/attendanceModel";
import RestService from "./rest";

export const serviceClient = new RestService({
  baseURL: baseUrl,
});
export const AttendanceDashboardService = (
  data: AttendanceDashboardPayload,
) => {
  return serviceClient.post(environment.urls.attendanceDashboard, data);
};
export const PendingApprovalListService = (
  data: PendingApprovalListPayload,
) => {
  return serviceClient.post(environment.urls.pendingAprovalList, data);
};
export const UploadedAttendanceViewService = (
  data: AttandanceDetailPayload,
) => {
  // // console.log(data, "fom service");

  return serviceClient.post(environment.urls.uploadedattendanceexcelview, data);
};
export const UpdateAttendanceService = (data: UpdateAttendancePayload) => {
  return serviceClient.post(environment.urls.updateAttendance, data);
};
export const AttendanceApprovalListService = (
  data: AttendanceApprovalPayload,
) => {
  return serviceClient.post(environment.urls.attendanceApproveList, data);
};
export const UpdateAttendanceApprovalStatusService = (
  data: UpdateAttendaceStatusPayload,
) => {
  return serviceClient.post(environment.urls.updateAttendanceApproval, data);
};
export const DeleteEmployeeFromAttendanceBatchService = (
  data: DeleteEmployeeAttendanceBatchPayload,
) => {
  return serviceClient.post(
    environment.urls.deleteEmployeeAttendanceFromBatch,
    data,
  );
};

export const AttendanceTimeSheetListService = (
  data: AttendanceTimeSheetCalculationPayload,
) => {
  return serviceClient.post(environment.urls.attendanceTimeSheet, data);
};

export const UploadAttendanceTimeSheetService = (
  data: UploadAttendanceTimeSheetPayload,
) => {
  return serviceClient.post(environment.urls.uploadAttendanceTimeSheet, data);
};

// Attendence New
export const GetAllEmpAttendanceService = (
  data: GetAllEmpAttendenceMonthlyPayload,
) => {
  let url = environment.urls.getAllEmpAttendenceMonthly;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const GetDayWiseEmpAttendenceService = (
  data: DaywiseAttendancePayload,
) => {
  let url = environment.urls.getDayWiseEmpAttendence;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const GenerateDaywiseAttendanceReportService = (
  data: DaywiseAttendanceReportPayload,
) => {
  return serviceClient.post(
    environment.urls.daywiseAttendanceReportGenerate,
    data,
  );
};
export const GetDaywiseAttendanceReportListService = (params?: {
  page?: number;
  limit?: number;
  status?: string;
  date?: string;
  search_text?: string;
}) => {
  let url = environment.urls.daywiseAttendanceReportList;
  const query: string[] = [];
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });
  }
  if (query.length > 0) {
    url = `${url}?${query.join("&")}`;
  }
  return serviceClient.get(url);
};
export const MonthwiseEmpAttendanceDetailsService = (
  data: MonthwiseEmpAttendenceDetailsPayload,
) => {
  return serviceClient.post(
    environment.urls.monthwiseEmpAttendenceDetails,
    data,
  );
};
export const SendForApprovalService = (data: SendForApprovalPayload) => {
  return serviceClient.post(environment.urls.sendForApproval, data);
};
export const ViewTeamAttendenceService = (data: ViewTeamAttendancePayload) => {
  let url = environment.urls.viewTeamAttendence;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const PendingAttendenceListService = (
  data: PendingAttendancePayload,
) => {
  return serviceClient.post(environment.urls.pendingAttendenceList, data);
};
export const EditAttendenceService = (data: EditAttendancePayload) => {
  return serviceClient.post(environment.urls.ediAttendence, data);
};
export const ApproveAttendenceService = (
  data: AttendanceApprovalDetailsPayload,
) => {
  return serviceClient.post(environment.urls.attendanceApproval, data);
};
export const MyAttendenceService = (data: MyAttendancePayload) => {
  return serviceClient.post(environment.urls.myAttendance, data);
};

export const GetEmpWiseYearlyAttendanceService = (
  data: GetEmpAttendanceYrlySummaryPayload,
) => {
  return serviceClient.post(environment.urls.getEmpWiseYearlyAttendance, data);
};

export const AttendanceDashboardMainService = (data: any) => {
  return serviceClient.post(environment.urls.attendanceDashboardUrl, data);
};

export const GetOrgHeadDashboardSnapshotService = (data: any) => {
  return serviceClient.post(environment.urls.orgHeadDashboardSnapshotUrl, data);
};

export const GetOrgHeadDashboardClassificationService = (data: any) => {
  return serviceClient.post(
    environment.urls.orgHeadDashboardClassificationUrl,
    data,
  );
};

export const GetOrgHeadDashboardTopListsService = (data: any) => {
  return serviceClient.post(environment.urls.orgHeadDashboardTopListsUrl, data);
};

export const GetOrgHeadDashboardEmployeesService = (data: any) => {
  return serviceClient.post(
    environment.urls.orgHeadDashboardEmployeesUrl,
    data,
  );
};

export const OrganizationReportCsvService = (data: {
  organization_id: number[] | null;
  departmentId?: number | null;
  atten_date?: string | null;
}) => {
  return serviceClient.postWithConfig(
    environment.urls.organizationReportCsv,
    data,
    { responseType: "blob" },
  );
};

export const attandanceClockInOutService = (data: any) => {
  return serviceClient.post(environment.urls.attendenceUploadUrl, data);
};

export const AppDashboadService = () => {
  return serviceClient.get(environment.urls.appDashboard);
};

export const GetAllTodaysProjectForTimesheetService = (payload: any) => {
  return serviceClient.post(
    environment.urls.getAllTodaysProjectForTimesheet,
    payload,
  );
};

export const SubmitTodaysTimesheetService = (
  payload: SubmitTodaysTimesheetPayload,
) => {
  return serviceClient.post(environment.urls.submitTodaysTimesheet, payload);
};

export const TerminateBatchInitiateService = () => {
  return serviceClient.get(environment.urls.terminateBatchInitiate);
};

export const GetAttendanceFailuresService = (params?: {
  employee_id?: string;
  organization_id?: number;
  attendance_date_from?: string;
  attendance_date_to?: string;
  source?: string;
  operation?: string;
  status?: string;
  search?: string;
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_order?: "asc" | "desc";
}) => {
  let url = environment.urls.attendanceFailures;
  const query: string[] = [];
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });
  }
  if (query.length > 0) {
    url = `${url}?${query.join("&")}`;
  }
  return serviceClient.get(url);
};

export const GetAttendanceFailureByIdService = (id: number) => {
  return serviceClient.get(`${environment.urls.attendanceFailures}/${id}`);
};

export const ResolveAttendanceFailureService = (id: number) => {
  return serviceClient.post(
    `${environment.urls.attendanceFailures}/${id}/resolve`,
    {},
  );
};

export const IgnoreAttendanceFailureService = (id: number) => {
  return serviceClient.post(
    `${environment.urls.attendanceFailures}/${id}/ignore`,
    {},
  );
};

export const GenerateAttendanceReportPdfService = (
  payload: GenerateMonthlyReportPayload,
) => {
  return serviceClient.post(
    environment.urls.generateAttendanceReportPdf,
    payload,
  );
};

export const GetAttendanceReportListService = (params?: {
  page?: number;
  limit?: number;
  month?: number;
  year?: number;
  status?: string;
  search_text?: string;
  organization_id?: number;
}) => {
  let url = environment.urls.attendanceReportList;
  const query: string[] = [];
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });
  }
  if (query.length > 0) {
    url = `${url}?${query.join("&")}`;
  }
  return serviceClient.get(url);
};

export const DownloadAttendanceReportService = (trackingId: string) => {
  return serviceClient.get(
    `${environment.urls.downloadAttendanceReport}/${encodeURIComponent(trackingId)}`,
  );
};

export const FutureAttendanceApprovalListService = (
  data: FutureAttendanceApprovalListPayload,
) => {
  return serviceClient.post(
    environment.urls.futureAttendanceApprovalList,
    data,
  );
};

export const FutureAttendanceApprovalUpdateStatusService = (
  data: FutureAttendanceApprovalUpdateStatusPayload,
) => {
  return serviceClient.post(
    environment.urls.futureAttendanceApprovalUpdateStatus,
    data,
  );
};

export interface FetchEmpAttendancePayload {
  empID: string;
  attendanceDate: string;
}

export interface UpdateEmpAttendancePayload {
  employee_id: string;
  attendance_date: string;
  checkin_time?: string | null;
  checkout_time?: string | null;
  break_time?: string | null;
  delete_attendance_ids?: number[] | null;
  remarks?: string;
  password?: string;
}

export interface UpdateEmployeeIdPayload {
  old_employee_id: string;
  new_employee_id: string;
}

export const FetchEmpAttendanceService = (data: FetchEmpAttendancePayload) => {
  return serviceClient.post(environment.urls.fetchEmpAttendance, data);
};

export const UpdateEmpAttendanceService = (
  data: UpdateEmpAttendancePayload,
) => {
  return serviceClient.post(environment.urls.updateEmpAttendance, data);
};

export const UpdateEmployeeIdService = (data: UpdateEmployeeIdPayload) => {
  return serviceClient.post(environment.urls.updateEmployeeId, data);
};

export const DownloadDaywiseAttendanceReportService = (trackingId: string) => {
  return serviceClient.get(
    `${environment.urls.daywiseAttendanceReportDownload}/${encodeURIComponent(trackingId)}`,
    { responseType: "blob" },
  );
};

export const GetOrganizationReportDataService = (
  data: OrganizationReportDataPayload,
) => {
  return serviceClient.post(environment.urls.organizationReportData, data);
};
